import { BucketS3Environment } from 'src/environments/environment';

export const BucketS3Env = {
  baseUrl: Object.prototype.hasOwnProperty.call(BucketS3Environment, 'bucket')
    ? BucketS3Environment.bucket
    : null,
};
